import { AxiosResponse } from 'axios';
import {
  IGetAdminTeachersParams,
  IGetAdminTeachersResponse,
  IGetAdminTeacherByIdResponse,
  IUpdateAdminTeacherPayload,
  IUpdateAdminTeacherResponse,
  ITeacherDeleteResponse,
} from '../../../interface/classveew-admin/admin-management.interface';
import { adminInstance } from '../../api';

/**
 * Get all teachers with pagination and filters
 */
export const getAdminTeachers = async (
  params: IGetAdminTeachersParams,
): Promise<AxiosResponse<IGetAdminTeachersResponse>> => {
  const response = await adminInstance.get<IGetAdminTeachersResponse>('/teachers', {
    params,
  });
  return response;
};

/**
 * Get teacher by ID
 */
export const getAdminTeacherById = async (
  teacherId: string,
): Promise<AxiosResponse<IGetAdminTeacherByIdResponse>> => {
  const response = await adminInstance.get<IGetAdminTeacherByIdResponse>(`/teachers/${teacherId}`);
  return response;
};

/**
 * Update teacher profile
 */
export const updateAdminTeacher = async (
  teacherId: string,
  data: IUpdateAdminTeacherPayload,
): Promise<AxiosResponse<IUpdateAdminTeacherResponse>> => {
  const response = await adminInstance.patch<IUpdateAdminTeacherResponse>(
    `/teachers/${teacherId}`,
    data,
  );
  return response;
};

/**
 * Permanently delete a teacher from the entire system (no request body).
 */
export const deleteAdminTeacher = async (
  teacherId: string,
): Promise<AxiosResponse<ITeacherDeleteResponse>> => {
  const response = await adminInstance.delete<ITeacherDeleteResponse>(`/teachers/${teacherId}`);
  return response;
};
